import FavoritesEmpty from "./FavoritesEmpty.tsx";
import DefaultTemplate from "../layout/content-templates/default/DefaultTemplate.tsx";
import { useFavoritesLoader } from "./favorites.ts";
import { useIntl } from "react-intl";
import ResponsiveAssetListAuto from "../../../common/features/asset/ResponsiveAssetListAuto.tsx";
import { useRef } from "react";
import React from "react";
import DotLoader from "../../../common/core-ui/DotLoader.tsx";
import { Await } from "react-router-dom";
import AssetCard from "../common/cards/AssetCard.tsx";
import PageTitle from "../common/page-title/PageTitle.tsx";
import ErrorBoundary from "common/core-ui/ErrorBoundary.tsx";
import DefaultErrorAssetCard from "../common/cards/DefaultErrorAssetCard.tsx";

export default function Favorites() {
  const data = useFavoritesLoader();
  const firstCardRef = useRef<HTMLLIElement>(null);
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Favorites" });

  return (
    <DefaultTemplate title={title}>
      <PageTitle title={title} />
      <React.Suspense fallback={<DotLoader />}>
        <Await resolve={data.favorites}>
          {(
            favoritesResult: Awaited<
              ReturnType<typeof useFavoritesLoader>["favorites"]
            >
          ) => {
            const favorites = favoritesResult.data ?? [];
            return favorites.length ? (
              <ResponsiveAssetListAuto>
                {favorites.map((asset, i) => {
                  return (
                    <ErrorBoundary
                      key={asset.manageAsset.vbid}
                      errorContent={<DefaultErrorAssetCard />}
                    >
                      <AssetCard
                        asset={asset}
                        lazyLoad={i > 20}
                        ref={i === 0 ? firstCardRef : undefined}
                        hideOnReturn={false}
                      />
                    </ErrorBoundary>
                  );
                })}
              </ResponsiveAssetListAuto>
            ) : (
              <FavoritesEmpty />
            );
          }}
        </Await>
      </React.Suspense>
    </DefaultTemplate>
  );
}
